import { IUserLoginPayload } from "../../../types/api/user";
import { useUserLogin } from "../../../hooks/api/user/hooks";
import { Button, Col, Form, Input, message, Row } from "antd";
import { setUserData } from "../../../lib/utils";

export default function Login() {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const { mutate, isPending } = useUserLogin({
    onSuccess: (res) => {
      setUserData(res.data);
      window.location.reload();
    },
    onError: (err) => {
      messageApi.error(err.message || "Login failed");
    },
  });

  return (
    <div className="h-screen w-full flex flex-col md:flex-row bg-[#EB8A39]">
      {contextHolder}

      {/* LEFT SECTION (Brand + Welcome Text) */}
      <div className="hidden h-full md:flex flex-col justify-between  w-full md:w-1/2 p-10 ">
        <div>
          <img
            src="/svg_logo.svg"
            alt="brand"
            className="w-[150px] object-contain"
          />
        </div>

        <div className="">
          <h1 className="text-[50px] font-semibold leading-[50px] text-black mb-4">
            Welcome to Elliotts Shah <br /> Chartered Accountants
          </h1>
          <p className="text-black text-base w-full">
            Enter your credentials to securely access user filings, CDD checks,
            payments, and reports.
          </p>
        </div>

      </div>

      {/* RIGHT SECTION (Form) */}
      <div className="w-full md:w-1/2 flex justify-center items-center px-6 py-10 bg-white rounded-l-[40px]">
        <div className="w-full    p-8">
          <h2 className="text-xl font-semibold mb-2">Log In</h2>
          <p className="text-sm text-gray-500 mb-6">
            Enter your credentials to securely access user filings, CDD checks,
            payments, and reports.
          </p>

          <Form
            form={form}
            layout="vertical"
            size="large"
            onFinish={(values: IUserLoginPayload) => mutate(values)}
          >
            <Row gutter={[16, 16]}>
              <Col span={24}>
                <Form.Item
                  name="email"
                  rules={[{ required: true, message: "Email is required" }]}
                >
                  <Input
                    className="border-[#B1B1B1] border-[2px]"
                    placeholder="Email" />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  name="password"
                  rules={[{ required: true, message: "Password is required" }]}
                >
                  <Input.Password                   className="border-[#B1B1B1] border-[2px]"
 placeholder="Password" />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Button
                  className="bg-[#EB8A39] text-black hover:text-white h-11 text-base rounded-full"
                  htmlType="submit"
                  block
                  loading={isPending}
                >
                  Log In
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </div>
  );
}
